import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from "./serviceWorker";
import "./index.css";

import App from "./App";

ReactDOM.render(
	<>
		<CssBaseline />
		<App />
	</>,
	document.getElementById("root"),
	() => {
		if (typeof window.finishProgress === "function") {
			window.finishProgress();
		}
	}
);

serviceworker.unregister();
